import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import {
	LoadingIndicatorService,
	UNIVERSAL_LOADING_KEY,
} from '../services/loading-indicator.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
	constructor(private readonly loadingService: LoadingIndicatorService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		let handled = false; // Flag to track if map or catchError was triggered
		this.loadingService.start(UNIVERSAL_LOADING_KEY);

		return next.handle(request).pipe(
			map((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
					handled = true;
					// Delaying stop for 1/2 second so when the response would navigate to the next page,
					// the loading indicator continues to show until the next page is loaded.
					setTimeout(() => {
						if (handled) {
							this.loadingService.stop(UNIVERSAL_LOADING_KEY);
						}
					}, 500);
				}
				return event;
			}),
			catchError((err) => {
				this.loadingService.stop(UNIVERSAL_LOADING_KEY);
				handled = true;
				return throwError(() => err);
			}),
			finalize(() => {
				// DE4981: only stop loading if neither map nor catchError was triggered.
				// This prevents an infinite loading spinner for "universal" loading events.
				if (!handled) {
					this.loadingService.stop(UNIVERSAL_LOADING_KEY);
				}
			})
		);
	}
}
